"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _immutable = _interopRequireDefault(require("immutable"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _SortOptionsDropdown = _interopRequireDefault(require("./SortOptionsDropdown"));

var _InlineCurrentFilters = _interopRequireDefault(require("./InlineCurrentFilters"));

var _GoodFiltersAndPage = _interopRequireDefault(require("../constants/GoodFiltersAndPage"));

var _langUtils = require("../utils/langUtils");

var _default = _react.default.createClass({
  displayName: "SortingBar",
  propTypes: {
    goodFilters: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
    numGoodsMatchingFilterCriteria: _react.PropTypes.number.isRequired,
    onGoodFilterChange: _react.PropTypes.func.isRequired,
    categoryFilter: _react.PropTypes.string.isRequired
  },
  calculatePageRangeStart: function calculatePageRangeStart(page, limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria === 0 ? 0 : page * limit + 1;
  },
  isLessThanOnePageOfResults: function isLessThanOnePageOfResults(limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria < limit;
  },
  isOnLastPageAndPageIsNotFull: function isOnLastPageAndPageIsNotFull(page, limit, numGoodsMatchingFilterCriteria) {
    return numGoodsMatchingFilterCriteria < page * limit + limit;
  },
  calculatePageRangeEnd: function calculatePageRangeEnd(page, limit, numGoodsMatchingFilterCriteria) {
    if (this.isLessThanOnePageOfResults(limit, numGoodsMatchingFilterCriteria)) {
      return numGoodsMatchingFilterCriteria;
    } else if (this.isOnLastPageAndPageIsNotFull(page, limit, numGoodsMatchingFilterCriteria)) {
      return numGoodsMatchingFilterCriteria;
    }

    return page * limit + limit;
  },
  render: function render() {
    var _this$props = this.props,
        goodFilters = _this$props.goodFilters,
        numGoodsMatchingFilterCriteria = _this$props.numGoodsMatchingFilterCriteria,
        onGoodFilterChange = _this$props.onGoodFilterChange,
        categoryFilter = _this$props.categoryFilter;
    var limit = goodFilters.get(_GoodFiltersAndPage.default.LIMIT);
    var page = goodFilters.get(_GoodFiltersAndPage.default.PAGE);
    return _react.default.createElement("div", null, _react.default.createElement("h2", {
      className: "m-bottom-0 m-right-4"
    }, (0, _langUtils.getCategoryOptionText)(categoryFilter)), _react.default.createElement(_UIFlex.default, {
      justify: "between"
    }, _react.default.createElement("div", {
      className: "m-top-2"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: 'sortingBar.pageRange',
      options: {
        beginningOfPageRange: this.calculatePageRangeStart(page, limit, numGoodsMatchingFilterCriteria),
        endOfPageRange: this.calculatePageRangeEnd(page, limit, numGoodsMatchingFilterCriteria),
        totalNumberOfGoods: numGoodsMatchingFilterCriteria
      }
    }), _react.default.createElement(_InlineCurrentFilters.default, {
      goodFilters: goodFilters,
      onGoodFilterChange: onGoodFilterChange
    })), numGoodsMatchingFilterCriteria > 0 && _react.default.createElement("div", null, _react.default.createElement(_SortOptionsDropdown.default, {
      onGoodFilterChange: onGoodFilterChange,
      sortingFilter: goodFilters.get(_GoodFiltersAndPage.default.SORT_BY)
    }))));
  }
});

exports.default = _default;
module.exports = exports.default;